<template>
  <Common>
    <template #list>
      <h2>{{$t('track.trackWay.uzbekistan.h2')}}</h2>

      <h3>{{$t('track.trackWay.uzbekistan.h3')}}</h3>
      <p>
        {{$t('track.trackWay.uzbekistan.p.01')}}<br />
        {{$t('track.trackWay.uzbekistan.p.02')}}<br />
        {{$t('track.trackWay.uzbekistan.p.03')}}<br />
        {{$t('track.trackWay.uzbekistan.p.04')}}<br />
        {{$t('track.trackWay.uzbekistan.p.05')}}<br />
        {{$t('track.trackWay.uzbekistan.p.06')}}<br />
      </p>
    </template>
    <!-- <template #pay>
      <h3>{{$t('track.trackWay.uzbekistan.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.uzbekistan.pay.p.01')}} <br />
        {{$t('track.trackWay.uzbekistan.pay.p.01')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";
export default {
  components: { Common },
};
</script>

<style>
</style>